import { reactive, watch } from 'vue';
import { useGuidedTour } from 'dashboard/composables/useGuidedTour';

/**
 * O "ME MOSTRA" do Lumos (Fase 1, 08/10/2026).
 *
 * O guia vem pronto do servidor (Captain::Copilot::Guias): rota e passos,
 * cada passo com o seletor do elemento que acende. Aqui só se executa: ir à
 * tela, esperar o elemento aparecer (a tela carrega depois da rota) e acender
 * com o tour que o produto já tem. O painel do Lumos sai da frente durante o
 * tour e volta no fim, onde a conversa estava.
 */
const ESPERA_MAXIMA = 4000;
const PASSO_DA_ESPERA = 100;

export const esperarAlvo = async (seletor, limite = ESPERA_MAXIMA) => {
  const inicio = Date.now();
  while (Date.now() - inicio < limite) {
    if (document.querySelector(seletor)) return true;
    // eslint-disable-next-line no-await-in-loop
    await new Promise(resolve => {
      setTimeout(resolve, PASSO_DA_ESPERA);
    });
  }
  return false;
};

export const passosDoGuia = (guia, achouAlvo) =>
  guia.passos.map((passo, i) => ({
    id: `${guia.id}-${i}`,
    target: passo.alvo,
    title: passo.titulo,
    content: passo.texto,
    // Sem o alvo na tela (largura de celular, permissão), o texto ainda
    // ajuda: o passo vem no centro em vez de apontar para o nada.
    position: achouAlvo ? passo.posicao || 'bottom' : 'center',
    highlight: achouAlvo,
    showSkip: i === 0,
    isLast: i === guia.passos.length - 1,
  }));

export function useMeMostra({ router, aoComecar, aoTerminar }) {
  const passos = reactive([]);
  const tour = useGuidedTour(passos, 'lumos_me_mostra');

  const mostrar = async guia => {
    if (!guia?.passos?.length) return;
    const atual = router.currentRoute.value;
    if (atual.name !== guia.rota) {
      await router.push({
        name: guia.rota,
        params: { accountId: atual.params.accountId },
      });
    }
    const achou = await esperarAlvo(guia.passos[0].alvo);
    // A tela pode ter aberto o tour de primeira visita dela: dois tours ao
    // mesmo tempo se cobririam. O dela já mostra o lugar.
    if (document.body.classList.contains('tour-active')) return;
    passos.splice(0, passos.length, ...passosDoGuia(guia, achou));
    aoComecar?.();
    tour.startTour();
  };

  watch(tour.isActive, (ativo, antes) => {
    if (antes && !ativo) aoTerminar?.();
  });

  return { tour, mostrar };
}
